/**
 * Language redirect
 */

/**
 * Read saved active language
 */
var readSavedLanguage = function() {

  var event = new CustomEvent(
    'BioRexReadSavedLanguage',
    {
      detail: {
        currentLanguage: BioRexMain.currentLanguage,
        savedLanguage: sessionStorage.getItem('BioRexSavedLanguage')
      }
    }
  );
  window.dispatchEvent(event);

};

/**
 * Maybe redirect to saved language
 */
var maybeRedirectToTranslation = function(event) {

  // console.log(event);
  // console.log(event.detail);

  var data = event.detail;

  var isRedirect = false;

  var referer = document.referrer;

  // Redirect if language has changed and referer is webshop (Webshop redirect everybody to Finnish version)
  if (
    data.currentLanguage !== data.savedLanguage
    && data.savedLanguage !== null
    && referer.indexOf(BioRexMain.webshopUrl) !== -1
  ) {

    // get corresponding link from head with same hreflang
    var link = document.querySelector('link[hreflang="' + data.savedLanguage + '"]');
    if (link) {
      // is redirect
      isRedirect = true;
      // get href from link
      var href = link.getAttribute('href');
      // save new language
      sessionStorage.setItem('BioRexSavedLanguage', data.savedLanguage);
      // redirect to href
      window.location = href;
    }

  }

  if (!isRedirect) {
    // save current language
    sessionStorage.setItem('BioRexSavedLanguage', data.currentLanguage);
  }

  // hook into dataLayer event etc.
  var readyEvent = new CustomEvent( 'BioRexLanguageRedirectChecked' );
  window.dispatchEvent(readyEvent);

};

document.addEventListener('DOMContentLoaded', function() {
  readSavedLanguage();
});

window.addEventListener('BioRexReadSavedLanguage', function(e) {
  maybeRedirectToTranslation(e);
});
